import React from "react";
import { useState } from "react";
import Modal from "../Modal";
import { Button } from "react-bootstrap";
import ImportNdcsForm from "./ImportNdcsForm";

const NdcsHeader = (props) => {
  const [showFileUploadModal, setShowFileUploadModal] = useState(false);

  const renderIntercomArticle = () => {
    return (
      props.intercomUrl && (
        <>
          Public list available <a href={props.intercomUrl}>here</a>.
        </>
      )
    );
  };

  const renderIntercomPreview = () => {
    return (
      !props.intercomUrl && (
        <>
          Preview <a href={props.intercomPreviewUrl}>here</a>.
        </>
      )
    );
  };

  return (
    <React.Fragment>
      <div className="pt-3 pb-2 row">
        <div className="col-9">
          <h1 className="h2">
            <i className="fa fa-capsules pe-2"></i>
            National Drug Codes (NDCs)
          </h1>
        </div>
        {props.can_validate ? (
          <div className="col-3 text-end">
            <Button
              className="btn btn-success btn-sm me-2"
              onClick={() => setShowFileUploadModal(true)}
            >
              <i className="fa fa-upload me-2"></i>
              Upload From File
            </Button>
          </div>
        ) : null}
      </div>
      <p className="text-muted">
        National Drug Codes by Manufacturer. {renderIntercomArticle()}
        {renderIntercomPreview()}
      </p>
      <Modal
        disableFooter={true}
        show={showFileUploadModal}
        title="Add NDCs From File"
        modalId={`upload_pid_ndc_modal`}
        modalSize="large"
        body={
          <ImportNdcsForm
            manufacturers={props.manufacturers}
            validate_url={props.validate_url}
            upload_url={props.upload_url}
            can_upload={props.can_upload}
          />
        }
        dismiss={() => {
          setShowFileUploadModal(false);
          location.reload();
        }}
      />
    </React.Fragment>
  );
};

export default NdcsHeader;
